import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Helmet } from 'react-helmet';
import axios from "axios"
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "../misc/Headings.js";
import Navbarlogedin from "./Navbarlogedin";
import { TextField, Grid, Box, Button } from "@mui/material";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import "./CompletedInterviews.css";
import RadioGroup from "@mui/material/RadioGroup";
import Typography from "@mui/material/Typography";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { CalendarPicker } from "@mui/x-date-pickers/CalendarPicker";
import UpcomingInterview from "./cards/UpcomingInterview"
import {
  Sunday,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
} from "./days";
/*imports end */

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const TextColumn = styled(Column)((props) => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft
    ? tw`md:mr-12 lg:mr-16 md:order-first`
    : tw`md:ml-12 lg:ml-16 md:order-last`,
]);

const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(
  SectionHeading
)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;
/**=============================================================================== */
const Issue = () => {

  const [date, setDate] = React.useState(new Date());
  const subheading = "",
    heading = (
      <>
        <span tw="text-changed-100">Reschedule your Mock Interview</span>
        <wbr />
      </>
    ),
    description =
      "Please Enter the Mock Interview ID and then proceed to reschedule your mock interview.",
    textOnLeft = true;
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.
  const [data, setData] = React.useState({
    textofArea: "",
  });
  const handleChangeofBox = (e) => {
    const value = e.target.value;
    setData({
      ...data,
      [e.target.name]: value,
    });
  };
  const [checked, setChecked] = React.useState("");
  const handleChangeRadio = (event) => {
    setChecked(event.target.value);
  };
  const [inputs, setInputs] = React.useState({
    idVerify: "",
  });
  
  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs({ ...inputs, [name]: value });
  };
  const display = (day,checked,id,desc) => {

    const date = day;
    day = day.getDay();
    if (day === 0) {
      return <Sunday date={date} checked={checked} id={id} desc={desc}/>;
    } else if (day === 1) {
      return <Monday date={date} />;
    } else if (day === 2) {
      return <Tuesday date={date} />;
    } else if (day === 3) {
      return <Wednesday date={date} />;
    } else if (day === 4) {
      return <Thursday date={date} />;
    } else if (day === 5) {
      return <Friday date={date} />;
    } else {
      return <Saturday date={date} />;
    }
  };
  const [cards,setCards]=React.useState(null)
  async function fetchData() {
    console.log(inputs.idVerify);
    console.log("id");
     if(inputs.idVerify===""){
      window.alert("Please enter a valid Mock Interview ID")
       return
     }
    await axios.get(
      `${process.env.REACT_APP_SERVER_URL}/api/get/${inputs.idVerify}`
    ).then((response) => {
      setCards(response.data)
    sessionStorage.setItem("details",JSON.stringify(response.data))
    console.log(JSON.parse(sessionStorage.getItem("details")).toname)
    }).catch((error) => {
      window.alert("Please enter a valid Mock Interview ID")
      console.error(error);
    })
    
  }

  return (
    <>
        <Helmet>
        <title>Interwiu | Reschedule your Interwiu</title>
        <meta name="description" content="Helmet application" />
    </Helmet>
      <Navbarlogedin />
      <Container>
        <TwoColumn>
          <TextColumn textOnLeft={textOnLeft}>
            <TextContent>
              {subheading && <Subheading>{subheading}</Subheading>}
              <Heading>{heading}</Heading>
              {description && <Description>{description}</Description>}
            </TextContent>
            <Grid container spacing={1}>
              <Grid item xs={3}>
                <TextField
                  id="outlined-basic"
                  label="Enter the Mock Interview ID"
                  variant="outlined"
                  type="text"
                  name="idVerify"
                  className="border-2 rounded"
                  value={inputs.idVerify}
                  onChange={handleChange}
                  placeholder="Last Name"
                  sx={{ width: "100%" }}
                />
                <Button onClick={fetchData}>Verify</Button>

              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={6}>
                <h5>Details of the Mock Interview </h5>
                {cards &&
                  <UpcomingInterview
                    name={JSON.parse(sessionStorage.getItem("details")).toname}
                  //  desg={result.desg}
                    profile={JSON.parse(sessionStorage.getItem("details")).profile}
                    price={JSON.parse(sessionStorage.getItem("details")).price}
                    slot={JSON.parse(sessionStorage.getItem("details")).slot}
                    status={JSON.parse(sessionStorage.getItem("details")).status}
                    payment={JSON.parse(sessionStorage.getItem("details")).payment}
                    id={JSON.parse(sessionStorage.getItem("details"))._id}
                    logo={require("../../images/amazon.png")}
                />
              }
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <FormControl
                sx={{ m: 3 }}
                component="fieldset"
                variant="standard"
              >
                <FormLabel component="legend">
                  Why do you want to reschedule this mock interview?
                </FormLabel>
                <FormGroup>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                  >
                    <FormControlLabel
                      value="one"
                      control={<Radio />}
                      onChange={handleChangeRadio}
                      label="I got something else to do at that time"
                    />
                    <FormControlLabel
                      value="two"
                      control={<Radio />}
                      onChange={handleChangeRadio}
                      label="I want to postpone it as I need more time to prepare for it"
                    />
                    <FormControlLabel
                      value="three"
                      control={<Radio />}
                      onChange={handleChangeRadio}
                      label="I want to prepone it as I will be prepared for it sooner"
                    />
                    <FormControlLabel
                      value="four"
                      control={<Radio />}
                      onChange={handleChangeRadio}
                      label="I want to prepone it because I want to appear for more mock interviews later"
                    />
                    <FormControlLabel
                      value="last"
                      control={<Radio />}
                      onChange={handleChangeRadio}
                      label="Other Reason"
                    />
                    <TextField
                      id="outlined-multiline-static"
                      name="textofArea"
                      label="Describe your issue(s) in detail"
                      multiline
                      rows={4}
                      sx={{ mt: 2 }}
                      value={data.textofArea}
                      onChange={handleChangeofBox}
                    />
                  </RadioGroup>
                </FormGroup>
              </FormControl>
            </Grid>

            <Grid item sx={{ mt: 2, mb: 2 }}>
              <Box>
                <Typography
                  id="modal-modal-title"
                  variant="h5"
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    mb: 2,
                  }}
                >
                  Choose a New Slot for Mock Interview {sessionStorage.getItem("details")?"with Mr."+JSON.parse(sessionStorage.getItem("details")).toname:""}
                </Typography>

                <Grid container spacing={2}>
                  <Grid xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <CalendarPicker
                        date={date}
                        format="dd/MM/yyyy"
                        onChange={(newDate) => setDate(newDate)}
                        views={["day"]}
                        disablePast={true}
                      />
                    </LocalizationProvider>
                  </Grid>

                  <Grid
                    xs={6}
                    sx={{
                      mt: 2,
                    }}
                  >
                    {display(date,checked,inputs.idVerify,data.textofArea)}
                  </Grid>
                  <Grid xs={12} sx={{ textAlign: "center" }}>
                    
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </TextColumn>
        </TwoColumn>
      </Container>
    </>
  );
};
export default Issue;
